import { get, set } from "idb-keyval";

const QUEUE_KEY = "sentinel_offline_queue_v1";

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function base64ToFile(base64, filename, mime) {
  const dataPart = base64.includes(",") ? base64.split(",")[1] : base64;
  const bstr = atob(dataPart);
  let n = bstr.length;
  const bytes = new Uint8Array(n);
  while (n--) bytes[n] = bstr.charCodeAt(n);
  return new File([bytes], filename || "foto.jpg", { type: mime || "image/jpeg" });
}

export async function getQueue() {
  return (await get(QUEUE_KEY)) || [];
}

async function saveQueue(queue) {
  await set(QUEUE_KEY, queue);
}

export async function queueSize() {
  return (await getQueue()).length;
}

/**
 * Guarda una acción (creación de incidencia, check-in, subida de evidencia...) para
 * sincronizarla en cuanto vuelva la conexión. `jsonPayload` para peticiones JSON o
 * `fields` (+ `file` opcional) para peticiones multipart/form-data. `chainedFile` +
 * `chainedUrlTemplate` (con un placeholder `{id}`) permiten encolar una subida de
 * evidencia que depende del `_id` devuelto por la petición principal (p. ej. la foto
 * de una incidencia creada sin conexión).
 */
export async function enqueue({ url, method = "post", jsonPayload = null, fields = null, file = null, chainedFile = null, chainedFields = null, chainedUrlTemplate = null, label }) {
  const queue = await getQueue();
  const item = {
    id: `pending-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    url,
    method,
    jsonPayload,
    fields,
    fileBase64: file ? await fileToBase64(file) : null,
    fileName: file?.name || null,
    fileType: file?.type || null,
    chainedEvidence: chainedFile
      ? {
          fields: chainedFields || {},
          fileBase64: await fileToBase64(chainedFile),
          fileName: chainedFile.name,
          fileType: chainedFile.type,
          urlTemplate: chainedUrlTemplate,
        }
      : null,
    label,
    created_at: new Date().toISOString(),
  };
  queue.push(item);
  await saveQueue(queue);
  return item;
}

export async function flushQueue(api) {
  const queue = await getQueue();
  if (queue.length === 0) return { synced: 0, remaining: 0 };
  const remaining = [];
  let synced = 0;
  for (const item of queue) {
    try {
      let createdId = null;
      if (item.jsonPayload) {
        const { data } = await api[item.method](item.url, item.jsonPayload);
        createdId = data?._id || null;
      } else {
        const fd = new FormData();
        Object.entries(item.fields || {}).forEach(([k, v]) => {
          if (v !== undefined && v !== null) fd.append(k, v);
        });
        if (item.fileBase64) fd.append("file", base64ToFile(item.fileBase64, item.fileName, item.fileType));
        await api[item.method](item.url, fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      if (item.chainedEvidence && createdId) {
        const ev = item.chainedEvidence;
        const fd2 = new FormData();
        Object.entries(ev.fields || {}).forEach(([k, v]) => {
          if (v !== undefined && v !== null) fd2.append(k, v);
        });
        if (ev.fileBase64) fd2.append("file", base64ToFile(ev.fileBase64, ev.fileName, ev.fileType));
        await api.post(ev.urlTemplate.replace("{id}", createdId), fd2, { headers: { "Content-Type": "multipart/form-data" } });
      }
      synced++;
    } catch (e) {
      remaining.push(item);
    }
  }
  await saveQueue(remaining);
  return { synced, remaining: remaining.length };
}
